import { IBank } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectBanks = (state: IApplicationState): IBank[] => {
  return state.promosPage.banks;
};
